<ng-container *transloco="let tAdOptions; read: 'advanced_options'">
    <app-tb-accordion
        [expanded]="true"
        [title]="tAdOptions(expanded ? 'hide_options' : 'show_options')"
        (expandedChange)="expanded = $event"
    >
        <div class="w-full flex flex-col gap-4 mt-4">
            <app-view-section
                [templateViews]="templateViews()"
                [schemaTabs]="schemaTabs()"
                (templateViewsChange)="updateTemplateViews($event)"
            ></app-view-section>
            <app-field-section
                [schemaTabs]="schemaTabs()"
                [fieldsBySchema]="fieldsBySchema()"
                [inactiveFields]="inactiveFields()"
                (fieldsBySchemaChange)="updateTemplateFields($event)"
                (inactiveFieldsChange)="updateInactiveFields($event)"
            ></app-field-section>
            <app-status-section
                [schemaTabs]="schemaTabs()"
                [fieldsBySchema]="fieldsBySchema()"
                [inactiveFields]="inactiveFields()"
                (fieldsBySchemaChange)="updateTemplateFields($event)"
            ></app-status-section>
        </div>
    </app-tb-accordion>
</ng-container>
